import React, { useEffect, useRef, useState } from 'react';
import { insuranceNetworkCreateForm } from '../utils/prop-types';
import { useMutation } from '@apollo/client';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CREATE_OR_UPDATE_INSURANCE_NETWORK from '../mutations/create-or-update-insurance-network.graphql';
import insuranceNetworkSchema from '../utils/insurance-network-schema';
import toastr from '../utils/toastr';
import styles from '../styles.module.scss';

const INITIAL_VALUES_DEFAULT = { name: '' };
const SERVER_VALIDATION_MESSAGES_DEFAULT = {};

const InsuranceNetworkCreateForm = ({
                                      showCreateForm,
                                      setShowCreateForm,
                                      addInsuranceNetwork
                                    }) => {
  const [serverValidationMessages, setServerValidationMessages] = useState(SERVER_VALIDATION_MESSAGES_DEFAULT);

  const formikRef = useRef();

  useEffect(() => {
    setServerValidationMessages(SERVER_VALIDATION_MESSAGES_DEFAULT);
  }, [showCreateForm]);

  const [callCreateInsuranceNetwork, { loading }] = useMutation(CREATE_OR_UPDATE_INSURANCE_NETWORK, {
    onCompleted: data => handleCompleted(data),
    onError: () => handleError()
  });

  const handleCompleted = (data) => {
    const { success, errors, insuranceNetwork } = data.createOrUpdateInsuranceNetwork;
    if (success) {
      addInsuranceNetwork(insuranceNetwork);
      toastr.success('Added successfully');
      formikRef.current.resetForm();
      setServerValidationMessages(SERVER_VALIDATION_MESSAGES_DEFAULT);
    } else {
      toastr.error('Cannot add this Insurance Network');
      setServerValidationMessages(errors);
    }
  };

  const handleError = () => {
    toastr.error('Something went wrong');
  };

  const handleCancelForm = () => {
    setShowCreateForm(false);
    setServerValidationMessages(SERVER_VALIDATION_MESSAGES_DEFAULT);
    formikRef.current.resetForm();
  };

  const saveInsuranceNetwork = async values => {
    setServerValidationMessages(SERVER_VALIDATION_MESSAGES_DEFAULT);
    const name = values.name.trim();
    await callCreateInsuranceNetwork({
      variables: { name }
    });
  };

  return (
    showCreateForm &&
    <div className={styles.formCreate}>
      <Formik
        initialValues={INITIAL_VALUES_DEFAULT}
        validationSchema={insuranceNetworkSchema}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize={true}
        innerRef={formikRef}
        onSubmit={values => saveInsuranceNetwork(values)}
      >
        {({ errors: formikValidationMessages}) => (
          <Form className={styles.form}>
            <div className={styles.field}>
              <div>
                <label>Name</label>
              </div>
              <div>
                <Field
                  className={formikValidationMessages.name || serverValidationMessages.name ? styles.inputError : ''}
                  name='name'
                  type='text'
                  autoFocus={true}
                />
                <ErrorMessage
                  className={styles.messageError}
                  component='span'
                  name='name'
                />
                {
                  !formikValidationMessages.name && serverValidationMessages.name &&
                  <span className={styles.messageError}>
                    {serverValidationMessages.name}
                  </span>
                }
              </div>
            </div>
            <div className={styles.field}>
              <div />
              <div>
                <button
                  className='button mr-1'
                  disabled={loading}
                  type='submit'
                >
                  {loading ? 'Saving...' : 'Save'}
                </button>
                <button
                  className='button secondary'
                  onClick={() => handleCancelForm()}
                  type='button'
                >
                  Cancel
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

InsuranceNetworkCreateForm.propTypes = insuranceNetworkCreateForm;

export default InsuranceNetworkCreateForm;
